// Mobile Dashboard 底部 Quick Access — 2026-09-16
//
// 设计意图:
// - Bottom Nav に無い 2 モジュール(Google Business / Instagram)を
//   Dashboard 末尾に露出することで「常用だけど 2 级页面」への導線を提供
// - 6 宫格版は以前削除済み。Bottom Nav 重复を避けるため 2 件のみ
// - Instagram は未接続なら行ごと非表示(2026-09-16 用户判断:
//   「接了才出现、没接就别出现」)
//
// Props:isInstagramConnected が false なら IG 行を完全に描画しない。

import { Link } from "react-router-dom";
import { MapPin, Instagram } from "lucide-react";
import { MobileCard } from "./MobileCard";

type Props = {
  isInstagramConnected: boolean;
};

export const MobileQuickAccessCard = ({ isInstagramConnected }: Props) => {
  return (
    <MobileCard title="クイックアクセス">
      <div className="mobile-quick-access">
        <Link
          to="/mobile/google-business"
          className="mobile-quick-access-item"
        >
          <span
            className="mobile-quick-access-icon"
            style={{ background: "#fef3c7", color: "#f59e0b" }}
          >
            <MapPin size={18} strokeWidth={2} />
          </span>
          <span className="mobile-quick-access-label">Google Business</span>
          <span className="mobile-quick-access-chevron">›</span>
        </Link>
        {isInstagramConnected && (
          <Link
            to="/mobile/instagram"
            className="mobile-quick-access-item"
          >
            <span
              className="mobile-quick-access-icon"
              style={{ background: "#fdf2f8", color: "#ec4899" }}
            >
              <Instagram size={18} strokeWidth={2} />
            </span>
            <span className="mobile-quick-access-label">Instagram</span>
            <span className="mobile-quick-access-chevron">›</span>
          </Link>
        )}
      </div>
    </MobileCard>
  );
};
